module.exports = __webpack_public_path__ + "img/basketball-ball.429f30af.svg";